var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-image-slider"},[_c('hooper',{ref:"carousel",attrs:{"settings":_vm.hooperSettings}},[_vm._t("default")],2),_vm._v(" "),_c('ef2-slider-navigation',{on:{"slider-next":_vm.handleSliderNext,"slider-previous":_vm.handleSliderPrevious}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }